import { Drawer } from 'components/Drawer'
import { Heading } from 'blaze-ui/Heading/Heading'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { DesignMenuDrawerProps } from './Types'
import { DesignMenuContainer } from './DesignMenuContainer'

export const DesignMenuDrawer = observer((props: DesignMenuDrawerProps) => {
  const { drawersStore } = useRootStore()
  const close = () => drawersStore.closeDrawer()

  return (
    <Drawer.Root {...props}>
      <Drawer.Portal>
        <Drawer.Overlay withBlur={false} />
        <Drawer.Content>
          <Drawer.InnerContent>
            <Drawer.Top>
              <div />
              <Drawer.Title asChild>
                <Heading level={5}>More Options</Heading>
              </Drawer.Title>
              <Drawer.Close label="Close" variant="ghost" position="right" />
            </Drawer.Top>
            <Drawer.Container>
              <DesignMenuContainer onAction={close} menuType="tray" {...props} />
            </Drawer.Container>
          </Drawer.InnerContent>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  )
})
